<template>
    <div class="application">
        <TransitionEffect>
            <NewEntryModal
                v-if="newEntryModal"
                :mediaType="mediaType"
                @close="newEntryModal=false"/>
        </TransitionEffect>

        <TransitionEffect>
            <UserList v-if="userListDialog.isVisible"
                :heading="siteContent.likedBy"
                :userIDs="userListDialog.users"
                @close="closeDialog"/>
        </TransitionEffect>

        <TransitionEffect>
            <SearchModal
                v-if="searchModal"
                @close="searchModal=false"/>
        </TransitionEffect>

        <MobileHeader/>
        <EmailVerification/>
        <Header
            @openNewEntryModal="handleUpload"
            @openSearchModal="searchModal=true"/>
        <RouterView/>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex'

    import Header            from '@/components/layout/Header'
    import EmailVerification from '@/components/templates/EmailVerification'
    import NewEntryModal     from '@/components/journal/main/NewEntryModal'
    import SearchModal       from '@/components/layout/header/SearchModal'
    import MobileHeader      from '@/components/layout/MobileHeader'
    import UserList          from '@/components/templates/UserList'

    export default {
        name: 'Application',
        components: {
            Header,
            EmailVerification,
            NewEntryModal,
            SearchModal,
            MobileHeader,
            UserList
        },
        data() {
            return {
                newEntryModal: false,
                searchModal: false,
                mediaType: ''
            }
        },
        methods: {
            ...mapActions('users', ['setUserListDialog']),

            handleUpload(mediaType) {
                if(this.auth.id) {
                    this.newEntryModal = true
                    this.mediaType = mediaType
                } else {
                    this.$router.push('/auth')
                }
            },
            closeDialog() {
                let dialog = {
                    isVisible: false,
                    users: []
                }

                this.setUserListDialog(dialog)
            }
        },
        computed: {
            ...mapState('users', ['lastVisitedSlug', 'userListDialog'])
        }
    }
</script>

<style scoped lang="scss">
    .application {
        display: flex;
        flex-direction: column;
        width: 100%;
        flex: 1;
    }
</style>